module.exports = __webpack_public_path__ + "static/img/news_13.388d634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_13.jpg
// module id = Cx2y
// module chunks = 2